var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.438 51.562C370.062 44.625 355.313 48.156 348.438 59.438C341.5 70.75 345.031 85.531 356.313 92.438C413.719 127.688 448 188.844 448 256C448 361.875 361.875 448 256 448S64 361.875 64 256C64 188.469 98.562 127.156 156.469 91.969C167.781 85.094 171.406 70.344 164.5 59C157.625 47.688 142.906 44.062 131.531 50.969C59.188 94.906 16 171.531 16 256C16 388.344 123.656 496 256 496S496 388.344 496 256C496 172.031 453.156 95.594 381.438 51.562ZM256 288C269.25 288 280 277.25 280 264V24C280 10.75 269.25 0 256 0S232 10.75 232 24V264C232 277.25 242.75 288 256 288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.4bdaa743f42e02a0c253627abec7abc9.svg";
export { ForwardRef as ReactComponent };